import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FAQ_PAGE_PATH } from '../shared/constants';
import { FaqComponent } from './faq.component';

const routes: Routes = [
  {
    path: FAQ_PAGE_PATH,
    component: FaqComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FaqRoutingModule {}
